import React, { useEffect, useState } from "react";
import {
  abhaCartDownloadServices,
  UpdateAbhaUserServices,
} from "../../services";
import { useSelector } from "react-redux";

const AbhaCard = ({ setIsVerifiedMobile }) => {
  const [abhacarddata, setAbhacarddata] = useState("");
  const userInfo = useSelector((state) => state.user.patientDetails);
  // const [updateuser, setUpdateUser] = useState(null);
  const downloadabha = async () => {
    try {
      const body = {
        xToken: userInfo.xToken,
      };
      const response = await abhaCartDownloadServices({ body });
      setAbhacarddata(response.result);
      console.log("object", response);

      if (response.status) {
        const patientData = JSON.parse(localStorage.getItem("selectedIndex"));
        console.log("patientData", patientData);
        console.log("userInfo id", patientData?.pId);

        const dob = new Date(userInfo.dob);
        const yyyy = dob.getFullYear();
        const mm = String(dob.getMonth() + 1).padStart(2, "0");
        const dd = String(dob.getDate()).padStart(2, "0");
        const formattedDob = `${yyyy}-${mm}-${dd}`;

        const body = {
          patientId: patientData?.pId,
          abhaAddress: userInfo.abhaAddress,
          healthIdnumber: userInfo.abhaNumber,
          abhaDOB: formattedDob,
          abhaGender: userInfo.gender,
          abhaName:
            userInfo.firstName +
            " " +
            userInfo.middleName +
            " " +
            userInfo.lastName,

          abhaCard: response.result,
        };
        const responsed = await UpdateAbhaUserServices({ body });
        // setUpdateUser(response);
        if (responsed.status) {
          localStorage.clear();
          console.log("ABHA user updated successfully");
        }
      }
    } catch (error) {
      console.error("Error while getting token:", error);
    }
  };
  const aabhacrt = "data:image/png;base64," + abhacarddata;

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = aabhacrt;
    link.download = "abha-card.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setIsVerifiedMobile(true);
  };

  useEffect(() => {
    downloadabha();
  }, []);
  return (
    <>
      <section className="container">
        <div className="abha-create-steps">
          <div className="row">
            <div className="col-md-6">
              <div className="create-abha">
                <h2>Create ABHA Number in 3 Steps</h2>
                <p>
                  Create ABHA Address and store all your medical records in one
                  place. Take part in the{" "}
                  <span className="highlight">
                    Ayushman Bharat Digital Mission (ABDM)
                  </span>{" "}
                  and get started on your digital health journey.
                </p>

                {/* Steps */}
                <div className="vertical-steps">
                  <div className="step-item">
                    <div className="step-marker">1</div>
                    <div className="step-content">
                      <h4>Verify Aadhaar Details</h4>
                      <p>
                        Enter your Aadhaar number and verify with OTP received
                        on Aadhaar linked mobile number.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">2</div>
                    <div className="step-content">
                      <h4>Link Mobile Number</h4>
                      <p>
                        Enter your mobile number and verify with OTP to link
                        with ABHA Address.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">3</div>
                    <div className="step-content">
                      <h4>Create ABHA</h4>
                      <p>Create your ABHA Number with a unique ABHA address.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Form Card */}
            <div className="col-md-6">
              <div className="form-card content">
                <h3>ABHA Address created successfully!</h3>
                <form className="pt-3">
                  <div className="col-ms-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
                    <div className="p-3 text-center">
                      <img src={aabhacrt} className="abha-card-download" />
                    </div>
                  </div>
                  <button className="continue-btn" onClick={handleDownload}>
                    DOWNLOAD YOUR ABHA CARD NOW
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AbhaCard;
